import React from 'react';

export const TableHeader = () => {
    return(
        <thead>
            <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Remove</th>
            </tr>
        </thead>
    );
};
